import { editorThemeNames, editorThemes } from "../constants/editor-theme";

const useTheme = (themeName = editorThemeNames.DEFAULT) => {
  const theme = editorThemes[themeName];
  return theme ? theme : editorThemes[editorThemeNames.DEFAULT];
};

export default useTheme;
